const $ = require('jquery');

module.exports = function (analytics) {
    return {
        restrict: 'A',
        scope: {},
        link(scope, element, attrs) {
            $(element).change(() => {
                analytics.pushEvent(attrs.analyticsInput);
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/analytics/analytics-input.directive.js